class Environment {
    setStripeKey() {
      if ( window.location.host == 'crm.gpsleaders.com' ) {
          return 'pk_live_IamHIhz7tjBFtx2RWo35Mkko'
      }
    
        return 'pk_test_2qCDVAbNAK50ONBYqUmpzZZK'
    }
}

export default new Environment()


// WEBPACK FOOTER //
// ./src/utils/environment.js